export const UPDATE_SPACEOWNER_DETAILS = 'UPDATE_SPACEOWNER_DETAILS';
export const UPDATE_SPACEOWNER_DETAILS_SUCCESS = 'UPDATE_SPACEOWNER_DETAILS_SUCCESS';
export const UPDATE_SPACEOWNER_DETAILS_FAILS = 'UPDATE_SPACEOWNER_DETAILS_FAILS';

export const FETCH_FILTERSPACENAME = 'FETCH_FILTERSPACENAME';
export const FETCH_FILTERSPACENAME_SUCCESS = 'FETCH_FILTERSPACENAME_SUCCESS';
export const FETCH_FILTERSPACENAME_FAILS = 'FETCH_FILTERSPACENAME_FAILS';

export const FETCH_SPACEDETAILS = 'FETCH_SPACEDETAILS';
export const FETCH_SPACEDETAILS_SUCCESS = 'FETCH_SPACEDETAILS_SUCCESS';
export const FETCH_SPACEDETAILS_FAILS = 'FETCH_SPACEDETAILS_FAILS';